import { Popover, Switch } from '@chakra-ui/react';
import { ChangeEvent } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { FilterPopoverButton, FilterPopoverContent } from '../FilterPopoverButton';

type Props = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export const BooleanFilterPopover = ({ label, value, onChange }: Props) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event?.target?.checked);
    state.onChange(event?.target?.checked);
  };

  return (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={label} />
      <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
        <Switch isChecked={state.value} onChange={handleChange} />
      </FilterPopoverContent>
    </Popover>
  );
};
